import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

export const LoadableConfirmNavigationDialog: ComponentType = lazyLoadOnRender({
  loader: () =>
    import(/* webpackChunkName: "4-feat-confirm-navigation-dialog" */ './ConfirmNavigationDialog').then(
      ({ ConfirmNavigationDialog }) => ({
        default: ConfirmNavigationDialog,
      })
    ),
});
